import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center bg-deep-azure overflow-hidden pt-32 pb-24" data-id="element-113">
      {/* Background imagery — ocean/leadership */}
      <div className="absolute inset-0" data-id="element-114">
        <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&q=80&w=1920" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" data-id="element-115" />
      </div>

      {/* Layered overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-deep-azure/95 via-deep-azure/85 to-deep-azure" data-id="element-116"></div>
      <div className="absolute inset-0 ocean-pattern opacity-50" data-id="element-117"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[60%] bg-azure/10 blur-[120px] rounded-full" data-id="element-118"></div>
      <div className="absolute bottom-0 right-0 w-[40%] h-[50%] bg-golden-yellow/5 blur-[120px] rounded-full" data-id="element-119"></div>

      {/* Subtle floating wave element */}
      <div className="absolute top-1/3 left-0 right-0 h-px bg-gradient-to-r from-transparent via-golden-yellow/30 to-transparent animate-wave" data-id="element-120"></div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 w-full relative z-10 text-center" data-id="element-121">
        <FadeIn data-id="element-122">
          <p className="text-[11px] font-medium tracking-[0.4em] uppercase text-golden-yellow mb-10" data-id="element-123">
            A Social Enterprise · Est. 2019
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-124">
          <h1 className="text-5xl md:text-7xl lg:text-[5.5rem] font-display font-medium leading-[1.05] mb-2 text-white tracking-tight" data-id="element-125">
            Changing Optics.
          </h1>
          <h1 className="text-5xl md:text-7xl lg:text-[5.5rem] font-display italic font-light leading-[1.05] mb-12 text-golden-yellow tracking-tight" data-id="element-126">
            Creating Outcomes.
          </h1>
        </FadeIn>

        {/* Editorial rule */}
        <FadeIn delay={0.2} data-id="element-127">
          <div className="editorial-rule w-32 mx-auto mb-12" data-id="element-128"></div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-129">
          <p className="text-lg md:text-xl text-white/70 mb-12 leading-relaxed max-w-3xl mx-auto font-light" data-id="element-130">
            LeadHERship Equity is advancing women founders and leaders through
            measurable support, strategic infrastructure, ecosystem
            intelligence, and economic access.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-131">
          <a href="#cta" className="inline-flex items-center justify-center gap-2 bg-vivid-orange hover:bg-vivid-orange-light text-white font-medium text-sm tracking-[0.05em] uppercase py-4 px-10 rounded-sm transition-all duration-300 w-full sm:w-auto group" data-id="element-132">
            Join the Research
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-133" />
          </a>
          <a href="#framework" className="inline-flex items-center justify-center border border-azure/60 hover:border-azure hover:bg-azure/10 text-azure font-medium text-sm tracking-[0.05em] uppercase py-4 px-10 rounded-sm transition-all duration-300 w-full sm:w-auto" data-id="element-134">
            Explore the Framework
          </a>
        </FadeIn>

        <FadeIn delay={0.5} className="mt-24 grid grid-cols-3 gap-8 max-w-3xl mx-auto pt-12 border-t border-white/10" data-id="element-135">
          {[{
          value: '225+',
          label: 'Founders Supported'
        }, {
          value: 'Ontario',
          label: '2025 Research Initiative'
        }, {
          value: '5-Step',
          label: 'Strategic Framework'
        }].map(stat => <div key={stat.label} data-id="element-136">
              <div className="text-3xl md:text-4xl font-display italic text-golden-yellow mb-2" data-id="element-137">
                {stat.value}
              </div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-white/50" data-id="element-138">
                {stat.label}
              </div>
            </div>)}
        </FadeIn>
      </div>

      {/* Bottom fade to next section */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-soft-white to-transparent pointer-events-none" data-id="element-139"></div>
    </section>;
}